export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function getKeyFromAccessor(accessor: (x: any) => any): string {
  const accessorSplit = accessor.toString().split(".");
  const updatedKey = accessorSplit[accessorSplit.length - 1];
  const finalKey = updatedKey.replace("}", "");
  return finalKey;
}